import { toLocalCurrency, toLocalNumber, type GraphItem, type ProductType, type SkuType } from "@client/api-services/client";
import { useUrlGenerator } from "~/apis/image-path";
import { useBrowserLocale } from "~/apis/utils";

function humanizeValidity(validity: number) {
	if (validity <= 1) return `${validity * 24} hours`;
	return `${validity} days`;
}
export function DataCard({ s, p, catalogItem }: { s: SkuType, p: ProductType, catalogItem: GraphItem }) {
	const { getCountryImageUrl, getOperatorImageUrl } = useUrlGenerator();
	const locale = useBrowserLocale();
	return <>
		<div className="flex gap-2">
			<img className="w-8 rounded-lg" src={getCountryImageUrl(p.countryCode, "4x3")} />
			<img className="w-8 rounded-lg bg-white object-contain" src={getOperatorImageUrl(catalogItem.imageName)} />
			<div className="ml-auto text-right font-semibold flex gap-1 items-baseline">
				<span>{s.skuName}</span>
			</div>
		</div>
		<div className="my-3"></div>
		<div className="flex items-baseline justify-between text-slate-700 gap-2">
			<div>
				<span className="text-2xl font-bold">{toLocalNumber(locale, s.localFaceValue.amount)}</span>
				<span>{s.localFaceValue.currencyCode}</span>
			</div>
			<span className="ml-auto text-xl font-semibold">
				{toLocalCurrency(locale, s.faceValue.amount, s.faceValue.currencyCode)}
			</span>
		</div>
		<hr className="border-t border-dashed border-t-slate-700/50 my-3" />
		<div className="leading-7">
			{s.dataPlan ? <div>
				<label>Data:</label>
				<label className="font-bold ml-1">{s.dataPlan}</label>
			</div> : null}
			{s.validityInDays ? <div>
				<label>Validity:</label>
				<label className="font-bold ml-1">{humanizeValidity(s.validityInDays)}</label>
			</div> : null}
		</div>
		<hr className="border-t border-dashed border-t-slate-700/50 my-3" />
		<div className="text-right">
			<button className="btn-dark-sm" type="submit" name="skuId" value={s.skuId}>add to cart</button>
		</div>
	</>
}
